import { parseSuccessfulResponse, RequestSender } from "./helpers";

export type AssignLicenseProps = {
  studentId: string;
  entitlementType: string;
};

async function assignLicense(
  request: RequestSender,
  input: AssignLicenseProps,
) {
  const response = await request("post", "/profile/assign-license", input);

  if (response.data.message !== "success") {
    throw new Error(response.data.message);
  }

  return parseSuccessfulResponse(response, (d) => d);
}

export default assignLicense;
